export default __webpack_public_path__ + "static/pr-249adf50055091fc477c8994ae97af5a.svg";